import React from "react";
import { ArrowRightIcon } from "lucide-react";
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  tone?: "wine" | "gold" | "outline";
  full?: boolean;
};
const tones = {
  wine: "bg-wine text-paper hover:bg-wineDark",
  gold: "bg-gold text-forestDeep hover:bg-goldSoft",
  outline: "bg-transparent text-forest ring-1 ring-inset ring-forest hover:bg-forest hover:text-paper"
};
export function CTAButton({
  children,
  href = "#precios",
  tone = "wine",
  full = false
}: CTAButtonProps) {
  return <a href={href} className={`group inline-flex items-center justify-center gap-3 rounded-full px-7 py-4 text-[15px] font-semibold tracking-wide transition-[background-color,color,transform] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 ${tones[tone]} ${full ? "w-full" : ""}`} data-id="element-87" data-mp="2oz88dqmxj0m8">
      <span className="text-center" data-id="element-88" data-mp="38p1ym09zx7oc">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden data-id="element-89" data-mp="38m62mhhpkt2j" />
    </a>;
}